<script>
    import { onMount, beforeUpdate, afterUpdate } from 'svelte';
    import { db } from './stores.js'
    export let display;
    let groups = [];
    let selectedGroup;
    let status='';

    onMount ( async() => {
        console.log('onMount Groups');
        $db.collection("groups").orderBy("name", "asc")
        .onSnapshot(function(querySnapshot) {
            console.log('querySnapshot: ', querySnapshot);
            groups = [];
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                groups = [...groups, {id:doc.id,...doc.data()}];
                console.log(doc.id, " => ", doc.data());
            });
        })
    });

    beforeUpdate(() =>{
        console.log('before update', display);

    });

    afterUpdate(() =>{
        console.log('after update');
    });

    async function handleSubmit(event){
        status = "";
        console.log('id: ', event.target.id.value);
        console.log('name: ', event.target.name.value);
        console.log('url-name: ', event.target.urlname.value);
        console.log('photo: ', event.target.photo.value);
        $db.collection('groups').doc(event.target.id.value).set({
            name: event.target.name.value,
            urlname: event.target.urlname.value,
            photo: event.target.photo.value
        }, { merge: true})
        .then(function() {
            status = "Group saved";
        }).catch(function(error){
            status = error.message;
        });
	}


</script>

{#if display === 'view'}
    <div id="groups-container">
        <section id="groups-list">
            <h1>View Groups</h1>
            {#each groups as group}
                <div>
                    {group.name}
                    <button on:click={() => selectedGroup = group}>select</button>
                </div>
            {:else}
                <p>loading...</p>
            {/each}
        </section>
        <section id="group-details">
            {#if selectedGroup}
                <div>id: {selectedGroup.id}</div>
                <img src={selectedGroup.photo} alt={selectedGroup.name}>
                <div>
                    photo url: <input value={selectedGroup.photo}/>
                </div>
                <div>
                    name: <input value={selectedGroup.name}/>
                </div>
                <div>
                    url name: <input value={selectedGroup.urlname}/>
                </div>
            {:else}
                <p>Select a Group</p>
            {/if}                
        </section>
    </div>
{:else if display === 'add'}
    <div id="add-form">
        <h1>Add a group</h1>
        <form id="add-group" on:submit|preventDefault={handleSubmit}>
            <label for="id">Enter id</label>
            <input type="number" id="id" required/>
            <label for="name">Enter name</label>
            <input type="text" id="name" required/>
            <label for="urlname">Enter url name</label>
            <input type="text" id="urlname" required/>
            <label for="photo">Enter photo url</label>
            <input type="text" id="photo" required/>
            <button type="submit">submit</button>
        </form>
        <div id="status">{status}</div>

    </div>
{/if}

<style>
    button {
        display: inline-block;
    }
    #groups-container {
        display: flex;
    }
    #group-details {
        position: sticky;
        top: 70px;
        height: 100%;
    }

    #group-details img{
        max-height: 100px;
        width: auto;
    }
</style>

